import { formatCurrency } from '@shared';

/**
 * Formats a currency value in a compact way for previews/small UI areas.
 * Prevents overflow by abbreviating very large numbers (e.g. $1.5T instead of full digits).
 */
export function formatCompactCurrency(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) {
    return '—';
  }
  const abs = Math.abs(value);
  const sign = value < 0 ? '−' : '';
  if (abs >= 1e15) {
    return `${sign}$1Q+`;
  }
  if (abs >= 1e12) {
    return `${sign}$${formatCurrency(abs / 1e12, 0, 2).replace('$', '')}T`;
  }
  if (abs >= 1e9) {
    return `${sign}$${formatCurrency(abs / 1e9, 0, 2).replace('$', '')}B`;
  }
  return formatCurrency(value);
}
